// TaskSelector.vue

<template>
    <v-dialog v-model="dialog" persistent scrollable max-width="800px">
      <v-card dark>
        <v-card-title primary-title>{{ formTitle }}
            <v-text-field flat solo-inverted clearable label="Suchen..." prepend-icon="search" class="hidden-sm-and-down" v-model="searchQuery">
            </v-text-field>
        </v-card-title>
        <v-card-text style="height: 450px;">
			<!--<v-expansion-panel light>
				<v-expansion-panel-content>
					<div slot="header">Item</div>-->
					<v-card>
						<v-card-text>
							<v-checkbox v-for="(item, index) in filteredItems" :key="index" :label="item.tsknr+' - '+item.name"
							 v-model="item.ischecked" ripple hide-details height="10" :disabled="item.isitem == 1"></v-checkbox>
						</v-card-text>
					</v-card>
				<!--</v-expansion-panel-content>
			</v-expansion-panel>-->
        </v-card-text>
        <v-card-actions>
          <v-btn flat color="orange" @click="cancel">Abbrechen</v-btn>
          <v-btn flat color="green" @click="submit(true)">Hinzufügen</v-btn>
          <v-spacer></v-spacer>
          <v-switch v-model="checkedOnly" label="ausgewählt"></v-switch>
        </v-card-actions>
      </v-card>
    </v-dialog>          
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  	name: 'TaskSelector',
  	props: {
  		parentItem: {
  			type: Object,
  		},
  	},
	data() {
		return {
			dialog: false,
			checkedOnly: false,
		}
	},
	computed: {
		...mapGetters({
			items: 'report/getTasks',
			editModel: 'common/getEditModel',
			selectorActive: 'common/getSelectorActive',
		}),
	    filteredItems: function () {
	      var self = this
	      if(!self.items.length) {return []}
	      //console.log(self.searchQuery == null ? self.searchQuery : self.searchQuery.length)
	      if(!self.searchQuery || self.searchQuery.length < 3) {
        	return self.items.filter(function (item) {
          		return !self.checkedOnly || item.ischecked//self.selected.includes(item.id)
          	})
	        //return self.items
	      } else {
	        return self.items.filter(function (item) {
	          var searchRegex = new RegExp(self.searchQuery, 'i')
	          return searchRegex.test(item.name) && (!self.checkedOnly || item.ischecked)
	        })
	      }
	    },
	    /*tasks: {
	        get () {
	          return this.$store.getters['report/getTasks']
	        },
	        set (tasks) {
	          console.log('settingTasks')
	          this.$store.dispatch('report/setTasks', tasks)
	        }
	    },*/
	    searchQuery: {
			get () {
				return this.$store.getters['common/getSearchQuery']
			},
			set (value) {
				this.$store.dispatch('common/setSearchQuery', value)
			}
	    },
        formTitle () {
			return 'eine oder mehrere Leistungen auswählen:'
			//return this.project ? 'New Item' : 'Edit Item'
		},
	},
	methods: {
		submit(save) {
			console.log(this.parentItem.id)
	        //this.editData = Object.assign({}, this.item)
	        /*const payload = {index: this.index, data: this.item}
	        if(this.index >= 0) {
	      		this.$store.dispatch('project/updateProject', payload)
	      	} else {
	      		this.$store.dispatch('project/createProject', payload)	      		
	      	}
      		//this.$store.dispatch('shared/clearEditModel')
			//console.log(this.editData.pronr +' '+ this.editData.name)*/
			var newtasks = this.items.filter(function(task) {
  				return (task.ischecked && !task.isitem);
			});
			//console.log(newtasks)
			for(var i=0; i<newtasks.length; i++) {
				console.log('save:'+save)
				if(save) {
					const data = {
						report_id: this.parentItem.id,
						task_id: newtasks[i].id,
						tsknr: newtasks[i].tsknr,
						ntsknr: newtasks[i].ntsknr,
						tskname: newtasks[i].name,
						unit: newtasks[i].unit,
						canedit: newtasks[i].canedit,
						comp: newtasks[i].comp,
						compk: newtasks[i].compk,
						task: newtasks[i],
					}
	        		const payload = {index: undefined, data: data}
	  				this.$store.dispatch('report/addRepitem', payload)
	  				newtasks[i].isitem = true
	  			} else {
  					newtasks[i].ischecked = false
	  			}
  			} 
      		this.$store.dispatch('common/updateSelectorSaved', true)  
      		this.$store.dispatch('common/updateSelectorActive', false)  
 			this.dialog = false		
		},
		cancel() {
      		//this.$store.dispatch('common/clearEditModel')
      		//this.$store.dispatch('shared/updateEditData', this.item)
			var newtasks = this.items.filter(function(item) {
  				return (item.ischecked && !item.isitem);
			});
			//console.log(newtasks)
			for(var i=0; i<newtasks.length; i++) {
  				newtasks[i].ichecked = false
  			} 
      		this.$store.dispatch('common/updateSelectorActive', false)  
 			this.dialog = false     		
		},
		toggleChecked() {

		},
	},
  	watch: {
	    selectorActive (newValue) {
		    if(newValue && this.editModel === 'tasks') {
		    	console.log('selectorActive(C):' + newValue)
	        	//this.item = Object.assign({}, this.model)
		    	//console.log(this.item)
				this.dialog = true
		    } else {
		    	console.log('selectorActive(C):' + newValue)
	        	//this.item = {}
				this.dialog = false
		    }
	    },
  	},
}  
</script>

<style scoped>
</style>